export default __webpack_public_path__ + "static/media/Swiss-Sweet-Pine.09660714.jpg";